import type { ComboboxItem, DataGridFilterRenderContext } from '@ibsys/kit';
import { Combobox } from '@ibsys/kit';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getShortName } from '@/shared/lib';
import { useUsers } from '../../api/hooks';

type Props = {
  ctx: DataGridFilterRenderContext;
};

/**
 * Фильтр колонки DataGrid по пользователю системы: Combobox с одиночным выбором и поиском
 * по имени на сервере. Значение фильтра — идентификатор пользователя.
 */
export const UserDataGridFilter: FC<Props> = ({ ctx }) => {
  const { t } = useTranslation('common');
  const [search, setSearch] = useState('');
  const { data, isFetching } = useUsers({ name: search || undefined, isActive: true, limit: 50 });

  const options = useMemo<ComboboxItem[]>(
    () =>
      (data?.users ?? []).map((user) => ({
        value: user.id,
        label: getShortName(user.firstName, user.lastName, user.middleName),
        description: user.email,
      })),
    [data?.users],
  );

  const selected = ctx.value as number | undefined;

  return (
    <div className="flex flex-col gap-2 p-2 min-w-56">
      <Combobox
        options={options}
        value={selected ?? undefined}
        onChange={(value) => ctx.setValue((value as number | undefined) ?? undefined)}
        onSearch={(query) => setSearch(query ?? '')}
        isLoading={isFetching}
        placeholder={t('select')}
        className="w-full"
      />
    </div>
  );
};
